import { render, staticRenderFns } from "./editarEndereco.vue?vue&type=template&id=6493cbc2"
import script from "./editarEndereco.vue?vue&type=script&lang=js"
export * from "./editarEndereco.vue?vue&type=script&lang=js"
import style0 from "./editarEndereco.vue?vue&type=style&index=0&id=6493cbc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports